import type { Middleware } from "@reduxjs/toolkit";
import { setUserProfile, logout } from "@reducers/user/userSlice";
import {
  clearPermissionCache,
  writePermissionCache,
} from "@utils/permissionCache";

/** Keep local permission cache in sync with Redux user (fast read on cold load / login). */
export const permissionCacheMiddleware: Middleware = () => (next) => (action) => {
  const result = next(action);
  if (setUserProfile.match(action)) {
    writePermissionCache(action.payload);
  } else if (logout.match(action)) {
    clearPermissionCache();
  }
  return result;
};
